import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import gridSvg from "../assets/svg/grid.svg";
import walletSvg from "../assets/svg/wallet.svg";
import adminSvg from "../assets/svg/adminSvg.svg";
import usersSvg from "../assets/svg/usersSvg.svg";
import reportSvg from "../assets/svg/svg58.svg";
import paymentSvg from "../assets/svg/paymentSvg.svg";
import collectionSvg from "../assets/svg/collection.svg";
import approvalSvg from "../assets/svg/Pulse.svg";
import setupSvg from "../assets/svg/setup.svg";
import logo from "../assets/img/Main logo.png";
import { setOpenKeys } from "../features/global/globalSlice";
import { formatImgPath } from "../utils";
import { useLocation, useNavigate } from "react-router-dom";

const icons = {
  gridSvg,
  walletSvg,
  adminSvg,
  usersSvg,
  paymentSvg,
  collectionSvg,
  approvalSvg,
  setupSvg,
  reportSvg,
};
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

export default function SideBarClosed() {
  const { sideMenuCollapsed, menuData } = useSelector((state) => state.global);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const generateMenuItems = (menuData) => {
    if (user?.changePassword === true || user?.changePassword === null) {
      return [];
    }
    const mapItems = (items, isChild) => {
      return items?.map((item) => {
        const iconSrc = icons[item?.mnIcons] || gridSvg;
        return getItem(
          item?.mnName.charAt?.(0)?.toUpperCase() + item?.mnName.slice(1),
          item?.mnLink,
          !isChild ? <img src={iconSrc} alt={item?.mnIcons} /> : null,
          item?.children && item?.children?.length > 0
            ? mapItems(item?.children, true)
            : null
        );
      });
    };
    if (!menuData || menuData?.length === 0) {
      return [];
    }

    return mapItems(menuData);
  };
  const items = [
    ...generateMenuItems(menuData),

    {
      type: "divider",
    },
  ];

  const location = useLocation();
  const currentPath = location.pathname;

  const [lastSelectedKey, setLastSelectedKey] = useState(null);

  const handleNavigation = async (e) => {
    setLastSelectedKey(e.key);
    await navigate(e.key);
  };
  useEffect(() => {}, [sideMenuCollapsed]);

  return (
    <>
      <div
        style={{
          borderInlineEnd: "1px solid rgba(5, 5, 5, 0.06)",
        }}
        className="flex flex-col h-full bg-[#f4f5f7]"
      >
        <Menu
          onClick={handleNavigation}
          defaultSelectedKeys={["dash", "/dashboard"]}
          defaultOpenKeys={[]}
          mode="inline"
          theme="light"
          inlineCollapsed={sideMenuCollapsed}
          items={items}
        />
      </div>
    </>
  );
}
